import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

const PHOTO_TYPES = ['habitat', 'cap_top', 'fertile_layer', 'stipe', 'cross_section', 'microscopy', 'other'];

export default function PhotoPicker({ value = [], onChange, photoTypes = PHOTO_TYPES }) {
  const { t: tc } = useTranslation('common');
  const cameraRef  = useRef(null);
  const galleryRef = useRef(null);

  const addFiles = (files) => {
    const entries = Array.from(files).map(file => ({
      file,
      photoType: 'other',
      previewUrl: URL.createObjectURL(file),
    }));
    onChange([...value, ...entries]);
  };

  const remove = (index) => onChange(value.filter((_, i) => i !== index));

  const setType = (index, type) =>
    onChange(value.map((item, i) => (i === index ? { ...item, photoType: type } : item)));

  return (
    <div style={{ marginTop: 14, borderTop: '1px solid var(--c-border)', paddingTop: 14 }}>
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8, color: 'var(--c-text-body-fg)' }}>
        Photos <span style={{ fontWeight: 400, color: 'var(--c-text-faint-fg)', fontSize: 12 }}>(optional)</span>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: value.length > 0 ? 12 : 0 }}>
        <button type="button" onClick={() => cameraRef.current?.click()} title={tc('tip.photoCamera')} style={btn('var(--c-info)')}>📷 {tc('photoPicker.camera')}</button>
        <button type="button" onClick={() => galleryRef.current?.click()} title={tc('tip.photoGallery')} style={btn('var(--c-text-muted)')}>🗂 {tc('photoPicker.gallery')}</button>
      </div>
      <input ref={cameraRef} type="file" accept="image/*" capture="environment"
        onChange={e => { if (e.target.files?.length) addFiles(e.target.files); e.target.value = ''; }}
        style={{ display: 'none' }} />
      <input ref={galleryRef} type="file" accept="image/*" multiple
        onChange={e => { if (e.target.files?.length) addFiles(e.target.files); e.target.value = ''; }}
        style={{ display: 'none' }} />

      {value.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {value.map((item, i) => (
            <div key={i} style={{ position: 'relative', width: 110 }}>
              <img src={item.previewUrl} alt=""
                style={{ width: 110, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid var(--c-border)', display: 'block' }} />
              <button type="button" onClick={() => remove(i)} title={tc('tip.photoRemove')}
                style={{ position: 'absolute', top: 2, right: 2, background: 'rgba(0,0,0,0.5)', color: 'var(--c-on-accent)', border: 'none', borderRadius: 4, width: 20, height: 20, cursor: 'pointer', fontSize: 13, lineHeight: '18px', padding: 0 }}>
                ×
              </button>
              <select value={item.photoType} onChange={e => setType(i, e.target.value)} title={tc('tip.photoKind')}
                style={{ width: '100%', marginTop: 4, fontSize: 11, padding: '2px 4px', border: '1px solid var(--c-border-strong)', borderRadius: 4 }}>
                {photoTypes.map(t => <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>)}
              </select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const btn = (bg) => ({
  background: bg, color: 'var(--c-on-accent)', border: 'none', borderRadius: 6,
  padding: '5px 12px', cursor: 'pointer', fontSize: 13,
});
